import clsx from 'clsx';
import {ReactNode} from 'react';

type PanelProps = {
  className?: string;
  children: ReactNode;
};

const Panel: React.FC<PanelProps> = ({className, children}) => {
  return (
    <div
      className={clsx(
        className,
        `max-w-screen-lg md:shadow-outline rounded flex flex-row w-full`,
      )}>
      <div className="flex flex-col p-5 w-full ">{children}</div>
    </div>
  );
};
export default Panel;
